import { useState } from "react"
import { useTranslation } from "react-i18next"
import { BetterDocExchangeDialog } from "@/modules/admin/better-doc/components/better-doc-exchange-dialog"

type BetterDocExchangeLinkProps = {
  exchangeId: number
}

export const BetterDocExchangeLink = ({ exchangeId }: BetterDocExchangeLinkProps) => {
  const { t } = useTranslation()
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  return (
    <>
      <button
        type="button"
        className="text-primary hover:underline"
        onClick={() => setIsDialogOpen(true)}
        data-testid={`better-doc-admin-exchange-link-${exchangeId}`}>
        {t("admin.betterDoc.exchangeLink", { exchangeId })}
      </button>
      {isDialogOpen ? <BetterDocExchangeDialog exchangeId={exchangeId} onClose={() => setIsDialogOpen(false)} /> : null}
    </>
  )
}
